import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export interface AuthUser {
  id: string;
  username: string;
  email?: string;
  display_name?: string;
  role: 'master' | 'admin' | 'operator' | 'viewer';
  permissions: string[];
}

interface AuthState {
  user: AuthUser | null;
  token: string | null;
  refreshToken: string | null;
  tenantId: string | null;
  tenantSlug: string | null;
  isAuthenticated: boolean;

  setSession: (payload: {
    user: AuthUser;
    token: string;
    refreshToken: string;
    tenantId: string;
    tenantSlug: string;
  }) => void;
  setToken: (token: string) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      refreshToken: null,
      tenantId: null,
      tenantSlug: null,
      isAuthenticated: false,

      setSession: ({ user, token, refreshToken, tenantId, tenantSlug }) =>
        set({ user, token, refreshToken, tenantId, tenantSlug, isAuthenticated: true }),

      setToken: (token) => set({ token }),

      logout: () =>
        set({
          user: null,
          token: null,
          refreshToken: null,
          tenantId: null,
          tenantSlug: null,
          isAuthenticated: false,
        }),
    }),
    {
      name: 'clone-chat.auth',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        user: state.user,
        token: state.token,
        refreshToken: state.refreshToken,
        tenantId: state.tenantId,
        tenantSlug: state.tenantSlug,
        isAuthenticated: state.isAuthenticated,
      }),
    },
  ),
);
